import ConfigHelper from "../../config/Config";
import InitHomeLogic from "./Home.logic";
import styles from "./Home.module.css";
import {
    FaClipboardCheck, FaUsers, FaCalendarPlus, FaCalendarTimes, FaStar,
    FaMoneyBillWave, FaReceipt, FaUserPlus, FaUserEdit, FaAddressBook,
    FaExclamationTriangle, FaUserSlash, FaPause, FaPauseCircle, FaChartBar,
    FaChalkboardTeacher, FaWallet, FaTags, FaSignOutAlt, FaChevronRight, FaBell,
} from "react-icons/fa";

interface ItemProps {
    icon: React.ReactNode;
    label: string;
    onClick: () => void;
    variant?: "primary" | "danger";
}

const MenuItem: React.FC<ItemProps> = ({ icon, label, onClick, variant }) => (
    <button type="button" className={styles.item} onClick={onClick}>
        <span className={`${styles.iconWrap} ${variant === "primary" ? styles.iconPrimary : variant === "danger" ? styles.iconDanger : ""}`}>
            {icon}
        </span>
        <span className={styles.label}>{label}</span>
        <FaChevronRight className={styles.chevron} />
    </button>
);

const HomeComponent: React.FC = () => {
    const { user, onClass, onPayment, onClientRegistration, onClientUpdate, onPayments, onClientsInMinus, onStopClient, onStopAll, onSurveyResults, onTrialClients, onClients, onSalaries, onSalary, onLogout, onTrainings, onBooking, onCancel, onInactiveClients, onTrainers, onTrainingCategories, onCancellations, onAdminNotifications } = InitHomeLogic();

    const isAdmin = user?.username === ConfigHelper.getAdminUsername();
    const isBlocked = user?.disabled === true;

    return (
        <div className="page-container">
            <div className={styles.header}>
                <h1 className={styles.logo}>RESET</h1>
                <p className={styles.subtitle}>pilates studio</p>
            </div>

            {!isBlocked && <>
                <p className={styles.sectionLabel}>Treninzi</p>
                <div className={styles.group}>
                    <MenuItem icon={<FaClipboardCheck />} label="Evidentiraj trening" onClick={onClass} />
                    <MenuItem icon={<FaUsers />} label="Grupe" onClick={onTrainings} />
                    {isAdmin && <>
                        <MenuItem icon={<FaCalendarPlus />} label="Zakazivanje" onClick={onBooking} />
                        <MenuItem icon={<FaCalendarTimes />} label="Otkazivanje" onClick={onCancel} />
                        <MenuItem icon={<FaStar />} label="Probni klijenti" onClick={onTrialClients} />
                    </>}
                </div>

                {isAdmin && <>
                    <p className={styles.sectionLabel}>Uplate</p>
                    <div className={styles.group}>
                        <MenuItem icon={<FaMoneyBillWave />} label="Uplata" onClick={onPayment} variant="primary" />
                        <MenuItem icon={<FaReceipt />} label="Pregled uplata" onClick={onPayments} />
                    </div>

                    <p className={styles.sectionLabel}>Klijenti</p>
                    <div className={styles.group}>
                        <MenuItem icon={<FaUserPlus />} label="Novi klijent" onClick={onClientRegistration} />
                        <MenuItem icon={<FaUserEdit />} label="Izmena klijenta" onClick={onClientUpdate} />
                        <MenuItem icon={<FaAddressBook />} label="Klijenti" onClick={onClients} />
                        <MenuItem icon={<FaExclamationTriangle />} label="Pregled dužnika" onClick={onClientsInMinus} />
                        <MenuItem icon={<FaUserSlash />} label="Pregled neaktivnih" onClick={onInactiveClients} />
                    </div>

                    <p className={styles.sectionLabel}>Stopiranje paketa</p>
                    <div className={styles.group}>
                        <MenuItem icon={<FaPause />} label="Stopiranje klijentu" onClick={onStopClient} />
                        <MenuItem icon={<FaPauseCircle />} label="Stopiranje svima" onClick={onStopAll} />
                    </div>

                    <p className={styles.sectionLabel}>Izveštaji</p>
                    <div className={styles.group}>
                        <MenuItem icon={<FaChartBar />} label="Rezultati upitnika" onClick={onSurveyResults} />
                        <MenuItem icon={<FaCalendarTimes />} label="Otkazivanja" onClick={onCancellations} />
                        <MenuItem icon={<FaBell />} label="Obaveštenja" onClick={onAdminNotifications} />
                    </div>

                    <p className={styles.sectionLabel}>Tim i usluge</p>
                    <div className={styles.group}>
                        <MenuItem icon={<FaChalkboardTeacher />} label="Treneri" onClick={onTrainers} />
                        <MenuItem icon={<FaWallet />} label="Plate" onClick={onSalaries} />
                        <MenuItem icon={<FaTags />} label="Usluge" onClick={onTrainingCategories} />
                    </div>
                </>}
            </>}

            <div className={styles.footer}>
                <button type="button" onClick={onSalary} className="btn-secondary">Moja plata</button>
                <button type="button" onClick={onLogout} className={styles.logout}>
                    <FaSignOutAlt style={{ marginRight: 8, verticalAlign: "middle" }} />
                    Odjavi se
                </button>
            </div>
        </div>
    );
}

export default HomeComponent;
